import script from "./recommon.vue?vue&type=script&setup=true&lang=ts"
export * from "./recommon.vue?vue&type=script&setup=true&lang=ts"

import "./recommon.vue?vue&type=style&index=0&id=36c34b3c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c34b3c"]])

export default __exports__